import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  StyledEngineProvider,
} from '@mui/joy';
import {
  BrowserRouter, Outlet, Route, Routes,
} from 'react-router-dom';
import { SpeedInsights } from '@vercel/speed-insights/react';
import Landing from 'Landing';
import Resume from 'Resume';
import ReactGA from 'react-ga4';
import 'App.global.scss';
import Projects from 'components/projects/Projects';
import ThemeLoader from 'components/ThemeLoader';
import NavigationBar from 'navigation/NavigationBar';
import AnalyticsBanner from 'components/AnalyticsBanner';
import Salam from 'components/Salam';
import NotFound from 'NotFound';

ReactGA.initialize('G-FN76P0DDSJ');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <React.StrictMode>
    <SpeedInsights />
    <StyledEngineProvider injectFirst>
      <ThemeLoader>
        <BrowserRouter>
          <AnalyticsBanner />
          <Salam />
          <Routes>
            <Route element={(
              <NavigationBar>
                <Outlet />
              </NavigationBar>
              )}
            >
              <Route path="/" element={<Landing />} />
              <Route path="/work" element={<Resume />} />
              <Route path="/projects" element={<Projects />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </ThemeLoader>
    </StyledEngineProvider>
  </React.StrictMode>,
);
